import { render } from "./ReviewCommentTable.vue?vue&type=template&id=09436ab2&ts=true"
import script from "./ReviewCommentTable.ts?vue&type=script&lang=ts&external"
export * from "./ReviewCommentTable.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__